<template>
	<div style="overflow: hidden;" :style="{'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px','color':data.config.textColor ||'','marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">
		<el-alert :background-color="data.config.containerBgColor" :color="data.config.textColor" :style="{'border-radius':data.config.borderRadius+'px','color':data.config.textColor ||''}" showIcon scrollable single :title="data.config.textContent" type="success"></el-alert>
	</div>
</template>

<script>
	export default {
		name: 'Tpl_Text',
		props: {
			data: {
				type: Object,
				default: () => ({})
			},
		},
		methods: {}
	};
</script>

<style scoped>
</style>